import { browser } from '$app/environment';

import { GA4_MEASUREMENT_ID } from '../configs';

export function getGAClientId() {
  if (!browser) return null;

  const match = document.cookie.match(new RegExp(`${GA4_MEASUREMENT_ID}=([^;]+)`));

  if (!match) return null;

  const cookieValue = match[1];
  const parts = cookieValue.split('.');

  if (parts.length < 4) return null;

  return `${parts[2]}.${parts[3]}`;
}
